module.exports = __webpack_public_path__ + "static/media/vertical-dots.03f1bbc5.svg";